// @flow
import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import colors from '../../styles/colors'

const Tab = styled(Link)`
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid rgb(220, 225, 230);

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &.active {
    box-shadow: inset 0 -2px ${colors.primary};
  }
`

const TabGroup = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const FaqTabs = () => (
  <div className="container">
    <TabGroup>
      <Tab to="/buying-with-us" activeClassName="active">
        Buying with us
      </Tab>
      <Tab to="/kief-realty-difference" activeClassName="active">
        How we&apos;re different
      </Tab>
      <Tab to="/rebate" activeClassName="active">
        Our rebate
      </Tab>
      <Tab to="/faq" activeClassName="active">
        Common questions
      </Tab>
    </TabGroup>
  </div>
)

export default FaqTabs



// WEBPACK FOOTER //
// ./src/components/FaqTabs/index.js